/**
 * History page module
 * 
 * @description
 * <p>Handles special scroll, styling and events for the History page</p>
 * <p>On page load, sets up hover events; adds decade background images</p>
 * <p>Self-initializes when you include this module.</p>
 * <p>Exposes: self.history.scrolling(), self.history.scrollIdx</p>
 * 
 * @module history
 * 
 * @example <caption>Usage of site.history.scrollIdx</caption>
 * {@lang JavaScript}
 * if(firstSegment === 'history' && site.history.scrollIdx <= 1) { ... }
 *
 * @namespace site.history
 */
( /* @lends module:history */ function(site,$){
	"use strict";
(function($){
	var dom = {},
		decades = [],
		scrollIdx = null,
		activeNav = null,
		trace = {push: function() {}};

	function init() {

		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};

		trace.push('[history.js] init()');

		// Find where to put decade background images. 

		dom.decadeBgs = $('.history-decade-bgs');
		
		/// Build the history time nav holder and mobile close button
		
		dom.timeline = $('.history-timeline');
		dom.timeline.prepend('<div id="history-nav"><button type="button" class="menu-btn"><svg class="arrow-right" width="26px" height="42px" viewBox="0 0 26 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Fill 2</title><desc>Created with Sketch.</desc><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="NBCU_DT_Home_Hybrid_Hover_Alt_BkdGradient" transform="translate(-1384.000000, -1397.000000)" fill="#FFFFFF"><g id="Featured_carousel" transform="translate(75.000000, 897.000000)"><g id="Scroll" transform="translate(1276.000000, 216.000000)"><polygon id="Fill-2" points="33 286.158128 55.5043371 305.002169 33 323.841872 33.9146358 326 59 305.002169 33.9146358 284"></polygon></g></g></g></g></svg><svg class="arrow-left" viewBox="0 0 26 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Fill 2</title><desc>Created with Sketch.</desc><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="NBCU_DT_Home_Hybrid_Hover_Alt_BkdGradient" transform="translate(-1384.000000, -1397.000000)" fill="#FFFFFF"><g id="Featured_carousel" transform="translate(75.000000, 897.000000)"><g id="Scroll" transform="translate(1276.000000, 216.000000)"><polygon id="Fill-2" transform="translate(46.000000, 305.000000) scale(-1, 1) translate(-46.000000, -305.000000) " points="33 286.158128 55.5043371 305.002169 33 323.841872 33.9146358 326 59 305.002169 33.9146358 284"></polygon></g></g></g></g></svg></button><nav id="history-nav-holder" aria-label="History Decades" role="navigation"></nav></div>');
		dom.timelineHolder = $('.history-timeline-holder');
		dom.nav = $('#history-nav');
		dom.navHolder = $('#history-nav-holder');

		dom.historyHero = $('.history-hero');
		decades.push({'obj':dom.historyHero, 'title':"Start"})

		// CMS will output decade background images as part of the content type. This finds them and puts them in the position fixed div .history-decade-bgs
		dom.decade = $('.history-decade');
		dom.decade.each(function(){
			var bg = $(this).find('.history-decade-bg');
			var title = $(this).find('.date').text()
			bg.prependTo(dom.decadeBgs);
			decades.push({'obj':$(this),'bg':bg,'title':title});
			
		});

		//// if decades can't be found stop js file
		if(dom.decade.length <= 1) return;

		/// add btns to the timeline nav
		decades.forEach(function(item,index) {
			add(item.title,index);	
		});

		///find all of the new timeline nav btns.
		dom.decadeBtn = $('.decade-btn');

		/// loop through timeline nav btns and a click event for scrolling to the decade, along with identifying the progress circle
		dom.decadeBtn.each(function(index){
			var $this = $(this),
				$thisLink = $this.find('.inactive-state > .title > a'),
				id = $this.attr('data-id');
			
			decades[index].btn = $this;
			decades[index].link = $thisLink;
			decades[index].progress = $this.find('.progress').find('.progress-svg').find('.circle');

			$this.on('click', function(){
				site.history.scrollIdx = index;
				scrollTo(id);
			});

            $thisLink.on('click', function(){
                site.history.scrollIdx = index;
                scrollTo(id);
            });
		});

		
		dom.nav.hasClass('active') ? activeNav = true : activeNav = false;
		dom.menuBtn = dom.nav.find('.menu-btn');
		dom.menuBtn.on('click', function(){
			toggleNav();	
		});

		dom.header = $('.site-header');

		checkHeight();

		window.addEventListener("orientationchange", function() {
			setTimeout(function(){ checkHeight(); }, 500);	
		});
		
		window.addEventListener("resize", resizeTimeline);


		dom.footer = $('footer');
		dom.document = $(document);
		scrolling();
		
	}

	
	/**
	 * closes the nav  on mobile/tablet
	 */
	function closeNav() {
		// trace.push('closeNav = ');
		dom.nav.removeClass('active');
		dom.timelineHolder.unbind('click');

		activeNav = false;
	}
	/**
	 * toggles the nav mobile/tablet
	 */
	function toggleNav() {
		// trace.push('toggleNav = ');
		if(activeNav) {
			dom.nav.removeClass('active');

			dom.timelineHolder.off('click touchstart');
			activeNav = false;
		} else  {
			dom.nav.addClass('active');	
			dom.timelineHolder.on('click touchstart', closeNav);

			activeNav = true;
		} 
	}
	/**
	 * if the browser resizes or reorientates calls CheckHeight to reevaluate the height of the timeline nav
	 */
	function resizeTimeline() {
		setTimeout(function(){ 
			checkHeight(); 
			checkOffset();
		}, 500);	
	}

	/**
	 * checks the height of the timeline nav and scales it to fit horizontally in the browser.
	 */
	function checkHeight() {

		// reset the scale so we can determine the actual height to scale
		dom.navHolder.css({'transform':'scale(1)'})

		var navH = dom.navHolder.outerHeight(),
			navT = dom.nav.position().top,
			winH = Math.floor($(window).innerHeight()) - navT;

		var scale = winH/navH;

		/// only scale if it's less than 1
		if(scale < 1 && scale > 0) dom.navHolder.css({'transform':'scale('+scale+')'})

		// trace.push('navH = '+navH+" navT = "+navT+" winH = "+winH+" scale = "+scale);
	}

	/**
	 * Checks nav top and footer and adds/removes new bottom value if footer is/isn't  visible
	 */
	function checkOffset() {
		// trace.push('[history.js] checkOffSet()');

		var	footerTop = dom.footer.offset().top,
			windowH = $(window).innerHeight(),
			winTop = Math.floor($(window).scrollTop()),
			distance = (winTop - footerTop + windowH) * -1;

		if(distance > 0) distance = 0;
		if(!site.checkMobile()) {
			dom.navHolder.css({"margin-top":distance});
			dom.footer.css({"position":"relative", "z-index":"10002"});
		}

		// trace.push('footerTop = '+footerTop+" windowH = "+windowH+" winTop = "+winTop+" distance "+distance);
	}

	/**
	 * add btns to the timeline nav
	 * @param {[type]} title text for the btn
	 * @param {[type]} id used to identify which decade to scroll to
	 */
	function add(title,id) {
		
		var progress = '<div class="progress"><svg class="progress-svg" viewbox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle class="circle" cx="50" cy="50" r="41"/></svg></div>',
		border = '<div class="border"><svg class="border-svg" viewbox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle class="circle" cx="50" cy="50" r="48"/></svg></div>';


		var decade = '<div class="decade-btn hoverable" data-id="'+id+'">';
			decade += '<div class="inactive-state">';
				decade += '<div class="title"><a tabindex="-1" aria-label="See more about'+title+'" role="menuitem" href="javascript:;">';
					decade += title;
				decade += '</a></div>';
				decade += '<div class="indicator">';
					decade += '<div class="dash"></div>';
					decade += '<div class="pip"></div>';
					decade += '<div class="dash"></div>';
				decade += '</div>';
			decade += '</div>';
			decade += '<div class="active-state">';
				decade += progress+border;
				decade += '<div class="title">';
					decade += title;
				decade += '</div>';
			decade += '</div>';
		decade += '</div>';
		dom.navHolder.append(decade);	
	}

	/**
	 * @public
	 * @function site.history.scrolling
	 * @desccription scrolling.js calls this function on user scroll, we check to see if the decade is visible and if so fade it in while fading out the active decadescrolling.js calls this function on user scroll, we check to see if the decade is visible and if so fade it in while fading out the active decade
	 * @example
	 * {@lang JavaScript}
	 * $(window).on('scroll',function() {
 	 *    scrolling();
	 *    site.history.scrolling();
	 *    site.newsroom.scrolling();
	 * });
	 */
	function scrolling() {
		//trace.push('scrolling decades'+decades.length);
		
		// if decades don't exist do nothing.
		if(dom.decade.length <= 1) return;
		//trace.push('')
		// look at all decades to find if they are visible
		decades.forEach(function(item) {
			var visible = site.scrolling.checkVisible(item.obj);

			//if(index <= 1) trace.push('visible = '+JSON.stringify(visible))

			if(visible.perc <= -100) {
				if(item.bg) item.bg.addClass('active');
				item.btn.addClass('active');
			} 

			if(visible.perc <= -200 || visible.perc > -100) {
				if(item.bg) item.bg.removeClass('active');
				item.btn.removeClass('active');
			} 

			item.progress.css({'stroke-dashoffset':getDashValue(41,visible.perc)});
		});
		//trace.push('')
		checkOffset();

	}

	/**
	 * used to animate the timeline nav btn progress circle
	 * @param  {[int]} radius     size of the circle
	 * @param  {[num]} percentage scrolling distance
	 * @return {[num]} circumference of the circle
	 */
	function getDashValue(radius, percentage) {
		// Using $radius, calculate circumference.
		var circumference = 2 * 3.1415927 * radius;

		// Convert percentage to decimal.
		// i.e. 50% = 0.5.
		var percentageDecimal = percentage / 100;

		// Return unit value.
		var value = circumference * percentageDecimal;
		//trace.push('value = '+value);
		return value;
	}

	/**
	 * scrolls to the decade in the timeline
	 * @param  {[type]} id int of which decade to scroll to
	 */
	function scrollTo(id) {
		
		var position = decades[id].obj.position().top+20;

		var winTop = Math.floor($(window).scrollTop());

		var distance = winTop - position;
		// trace.push("distance = "+distance);

		if(distance < 0) distance = distance *-1;
		// trace.push("distance = "+distance);

		// var time = (distance/3000) * 1000;
		// var time = 2000;
		
		// trace.push('scrollTo time '+time+" position = "+position+" winTop = "+winTop+" distance = "+distance);

		// redmine #2478
		// History: timeline nav - remove the sliding animation when clicking/tapping decades
		// $('html,body').animate({ 'scrollTop': position }, time, function(){
		// 	site.history.scrollIdx = null;
		// });
		$('html,body').scrollTop(position);
	}


	

	

	// Public API definitions
	site.history = {
		scrolling : scrolling,
		scrollIdx: scrollIdx
	};


	$(function(){
		init();
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);
